import { put, select, takeLatest } from 'redux-saga/effects'
import { getInsuranceInformationStateSelector } from '../selectors'
import { IInsuranceInformationState } from '../store/insuranceInformation.types'
import { InsuranceInformationConstants } from '../store/insuranceInformation.constants'
import { setInsuranceInformationList } from '../store/insuranceInformation.actions'

export function* removeInsuranceInformation() {
  const insuranceInformation: IInsuranceInformationState = yield select(getInsuranceInformationStateSelector)
  const { insuranceInformationList, selectedInsuranceKey } = insuranceInformation
  if (selectedInsuranceKey) {
    const updatedInsuranceInformationList = insuranceInformationList.filter(
      (insuranceInfo) => insuranceInfo.key !== selectedInsuranceKey
    )
    yield put(setInsuranceInformationList(updatedInsuranceInformationList))
  }
}

export function* removeInsuranceInformationSaga() {
  yield takeLatest([InsuranceInformationConstants.REMOVE_INSURANCE_INFORMATION], removeInsuranceInformation)
}
